import milestoneController from "../../../controllers/milestoneController/controller";
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';
export default {
    name: 'SimpleTable',
    data() {
        return {
            company: '',
            milestoneList: [],
            currentPage: 1,
            pageSize: 10,
            totalMilestone: 0,
            totalPages: 0,
            searchQuery: '',
            allIcons: [],
            dropdownOpen: false,
            icons: [],
            iconSearch: '',
            milestone: {
                tahun : '',
                keterangan : '',
                icon: '',
                status: '',
                language: '',
                created_by: '',
                created_by_name: '',
                created_on: '',
            },
            selectedMilestone: {
                updated_by: '',
                updated_by_name: '',
            }
        }
    },
    computed: {        
        filteredMilestone(){
            return this.milestoneList.filter(milestone => milestone.keterangan.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
        pages(){
            return Math.ceil(this.totalMilestone / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods:{
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.milestone.created_by = id;
            this.selectedMilestone.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.milestone.created_by_name = name;
            this.selectedMilestone.updated_by_name = name;
        },
        showModal(type, id) {
            this.user();
            const milestone = this.milestoneList.find(milestone => milestone.id === id);
            if (milestone) {
                this.milestone = milestone;
                
                const modal = document.getElementById(type === 'edit' ? 'editMilestone' : 'detailMilestone');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
          const modalIds = ['tambahMilestone', 'editMilestone', 'detailMilestone'];
          modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
              modal.classList.remove('show');
              setTimeout(() => {
                modal.style.display = 'none';
              }, 300);
            }
          });
        
          // Hapus backdrop
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
              if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
              }
            }, 300);
          });
        
          // Hapus kelas atau atribut yang mengunci scroll pada body
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.overflow = ''; // Menghapus properti overflow jika ada
          this.fetchMilestone();
          this.resetForm();
        },    
        resetForm() {
            this.iconSearch = '';
            this.milestone.tahun = '';
            this.milestone.keterangan = '';
            this.milestone.icon = '';
            this.milestone.language = '';
            this.milestone.status = '';
            this.icon();
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchMilestone();
            }
        },
        async fetchMilestone() {
            try {
                const company_id = this.company;        
                console.log(company_id);
                //TERANG
                if (company_id !== '1') {
                    this.$router.replace({ path: '/' });
                    console.log('DISINI');
                    return;
                }
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await milestoneController.fetchMilestone(query, this.currentPage, this.pageSize, company_id);
                this.milestoneList = response.data;
                this.totaAllMilestone();
            } catch (error) {
                console.error('Error fetching Milestone:', error);
            }
        },
        async totaAllMilestone() {
            try {
                const company_id = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await milestoneController.totalAllMilestone(query, company_id);
                this.totalMilestone = response.data;
            } catch (error) {
                console.error('Error fetching Milestone:', error);
                throw error;
            }
        },
        async addMilestone() {
            try {
                const tahun = this.milestone.tahun;
                const keterangan = this.milestone.keterangan;
                const icon = this.milestone.icon;
                const language = this.milestone.language;
                const status = this.milestone.status;
                const created_by = this.milestone.created_by;
                const company_id = this.company;
                const created_by_name = this.milestone.created_by_name;
                if (!tahun || !icon || !keterangan || !status || !language || !created_by || !created_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                }
                const now = new Date();
                this.milestone.created_on = now.toISOString().slice(0, 19).replace('T', ' '); // Format MySQL
                const add = {
                    year : tahun,
                    description : keterangan,
                    icon : icon,
                    language : language,
                    is_active : status,
                    id_company : company_id,
                    created_by : created_by,
                    created_by_name : created_by_name,
                    created_on : this.milestone.created_on,
                }
                const response = await milestoneController.addMilestone(add);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Milestone berhasil ditambahkan',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.closeModal();
                    this.resetForm();
                    this.fetchMilestone();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        time: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal menambahkan data',
                    text: error.message,
                    time: 1500
                })
                throw error;
            }
        },
        async updateMilestone() {
            try {
                const id = this.milestone.id;
                const tahun = this.milestone.tahun;
                const keterangan = this.milestone.keterangan;
                const icon = this.milestone.icon;
                const language = this.milestone.language;
                const status = this.milestone.status;
                const updated_by = this.selectedMilestone.updated_by;
                const updated_by_name = this.selectedMilestone.updated_by_name;
                const now = new Date();
                const update_on = now.toISOString().slice(0, 19).replace('T', ' ');
                if (!tahun || !icon || !keterangan || !status || !updated_by || !updated_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal memperbaharui data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                }
                const update = {
                    id: id,
                    year : tahun,
                    description : keterangan,
                    icon : icon,
                    language : language,
                    is_active : status,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    updated_on: update_on
                };
                const response = await milestoneController.updateMilestone(update);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Milestone berhasil diperbaharui',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.closeModal();
                    this.fetchMilestone();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal memperbaharui data',
                        time: 1500
                    });
                    this.closeModal();
                    this.fetchMilestone();
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal memperbaharui data',
                    text: error.message,
                    time: 1500
                })
                throw error;
            }
        },
        async deleteMilestone(id){
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    await milestoneController.deleteMilestone(id);
                    Swal.fire({
                        icon: 'success',
                        title: 'Milestone berhasil dihapus',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.fetchMilestone();
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menghapus data',
                        text: error.message,
                        time: 1500
                    })
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        },
        async icon(){
            const res = await fetch('https://raw.githubusercontent.com/twbs/icons/main/font/bootstrap-icons.json');
            const data = await res.json();
            this.allIcons = Object.keys(data).map(name => `bi bi-${name}`);
            this.icons = this.allIcons;
        },
        selectIcon(icon) {
            this.milestone.icon = icon;
            this.dropdownOpen = false;
        },
        searchIcon() {
            const keyword = this.iconSearch.toLowerCase();
            this.icons = this.allIcons.filter(icon =>
                icon.toLowerCase().includes(keyword)
            );
        }
    },
    mounted(){
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
        this.icon();
        this.icons = this.allIcons; 
    },
    beforeDestroy() {
        // bersihkan listener
        EventBus.$off("companyChanged", this.onCompanyChange);
    },
    watch: {
        searchQuery: {
            handler: 'fetchMilestone',
        },
        company: {
            handler: 'fetchMilestone'
        }
    },
    created() {
        this.icons = this.allIcons; // Awal: tampilkan semua
    },
}